import React from 'react'

import { At, Block, HLine, LINE, Sheet, VLine } from './_shared/positioned'

// Réplica do modelo "Carta de Autorização / Letter of Authorization" da Biofix, com as coordenadas em pt do
// modelo. A tabela de porões é dinâmica: o resto do documento desce ou sobe conforme o número de linhas.
const FONT = "'Times New Roman', Times, 'Liberation Serif', serif"
const LEFT = 23.3
const RIGHT = 598.8
const WIDTH = RIGHT - LEFT
const SIZE = 11
const ROW_HEIGHT = 14.2
const COLUMNS = [147.8, 153.6, WIDTH - 147.8 - 153.6]

const Bold = ({ children }) => <span style={{ fontWeight: 'bold' }}>{children}</span>

const Centered = ({ x = LEFT, w = WIDTH, ...props }) => <At x={x} w={w} align="center" {...props} />

const Header = ({ data }) => (
  <Block top={25.6} height={63.1} borders="tb">
    <img
      src="/pdfs/biofix/logo.png"
      alt="Biofix Agri"
      style={{ position: 'absolute', left: `${189.7 - LEFT}pt`, top: '2.4pt', width: '210pt', height: '58.5pt' }}
    />
    <VLine x={439.8} y1={25.6} y2={88.7} />
    <HLine x1={439.8} x2={RIGHT} y={52.5} />
    <At x={441.8} y={33.8} size={SIZE}>
      O.S.
    </At>
    <At x={534} y={33.8} size={SIZE}>
      {data.activityCode}
    </At>
    <At x={441.8} y={65.3} size={SIZE}>
      Nº Comunicado
    </At>
    <At x={534} y={65.3} size={SIZE}>
      {data.communicationNumber}
    </At>
  </Block>
)

const Text = ({ data }) => (
  <Block top={88.7} height={273.3} plain>
    <Centered y={91.3} size={12} bold>
      CARTA DE AUTORIZAÇÃO
    </Centered>
    <Centered y={106.3} size={10} italic>
      LETTER OF AUTHORIZATION
    </Centered>
    <At x={25.3} y={123.2} size={12}>
      Ao Chefe da Unidade do VIGIAGRO - Ministério da Agricultura, Pecuária e Abastecimento
    </At>
    <At x={25.3} y={137.4} italic>
      To the head of Department Agriculture Phytossanitary Bureau Regulation Office
    </At>
    <At x={25.3} y={153.5} size={12}>
      No cumprimento da Portaria nº 675, de 11 de novembro de 1960, e do Regulamento de Defesa Sanitária Vegetal -
    </At>
    <At x={25.3} y={168.6} size={12}>
      RDSV, Decreto nº 24.114/34, e na qualidade de agente marítimo do Navio:
    </At>
    <At x={400} y={168.6} size={12} bold>
      {data.ship}
    </At>
    <At x={25.3} y={183.7} w={573} size={12} wrap style={{ lineHeight: '15.1pt' }}>
      Permitimos a realização de fumigação da(s) mercadoria(s) contida(s) no(s) porão(ões) do navio, conforme descrição
      abaixo, e nos comprometemos a cumprir as normas técnicas e legais necessárias à eficiência da operação e segurança
      da tripulação.
    </At>
    <At x={25.2} y={243.9} italic>
      In compliance with Regulation nº 675 of November 11th, 1960 and the Department Agriculture Phytossanitary
    </At>
    <At x={25.2} y={258.1} italic>
      Bureau regulation, decree nº 24.144/34 and as agent of
    </At>
    <At x={326.6} y={258.1} bold italic>
      {data.ship}
    </At>
    <At x={25.2} y={272.3} italic>
      We authorize the Phytossanitary Treatment of Goods into hold(s) of vessel, according to description below and
    </At>
    <At x={25.2} y={286.5} italic>
      we undertake to comply with the technical and legal recommendatioas essential for the efficiency of treatment
    </At>
    <At x={25.2} y={300.7} italic>
      and crew’s safety.
    </At>
    <At x={25.3} y={324.5} size={12}>
      Declaramos que os porões abaixo apresentam-se em perfeitas condições para realização do tratamento:
    </At>
    <At x={25.2} y={338.7} italic>
      We state that the hold(s) below is/are in good conditions for the phytossanitary treatment.
    </At>
  </Block>
)

const Summary = ({ data }) => (
  <>
    <Block top={362} height={123.3} borders="tb">
      <HLine x1={LEFT} x2={RIGHT} y={403.1} />
      <HLine x1={LEFT} x2={RIGHT} y={444.2} />
      <VLine x={324.7} y1={362} y2={403.1} />
      <VLine x={393.7} y1={444.2} y2={485.3} />
      <At x={25.2} y={364}>
        Mercadoria/Commodity:
      </At>
      <Centered x={LEFT} w={324.7 - LEFT} y={378.2} bold>
        {data.goodsPt}
      </Centered>
      <Centered x={LEFT} w={324.7 - LEFT} y={391} bold>
        {data.goodsEn}
      </Centered>
      <At x={326.6} y={364}>
        Quantidade / Quantity:
      </At>
      <At x={347.5} y={378.2} bold>
        APROX..
      </At>
      <Centered x={413.2} w={100} y={378.2} bold>
        {data.quantity}
      </Centered>
      <At x={534} y={378.2} bold>
        TM
      </At>
      <At x={367.4} y={391}>
        ABT.
      </At>
      <Centered x={413.2} w={100} y={391} bold>
        {data.quantity}
      </Centered>
      <At x={534} y={391} bold>
        MT
      </At>
      <At x={25.2} y={405.2}>
        Nome da empresa Fumigadora / Company:
      </At>
      <Centered x={230} w={RIGHT - 230} y={405.2} bold>
        BIOFIX AGRI LTDA
      </Centered>
      <At x={25.2} y={446.3}>
        Produto Fumigante (P.A) / Fumigation Product
      </At>
      <At x={25.2} y={460.5} bold>
        FOSFETO DE ALUMÍNIO / ALUMINIUM PHOSPHIDE
      </At>
      <Centered x={393.7} w={RIGHT - 393.7} y={446.3}>
        Data de Fumigação / date of Fumigation:
      </Centered>
      <Centered x={393.7} w={RIGHT - 393.7} y={460.5} bold>
        {data.datePt}
      </Centered>
      <Centered x={393.7} w={RIGHT - 393.7} y={473.2}>
        {data.dateEn}
      </Centered>
    </Block>
    <Block top={485.3} height={27} plain>
      <Centered y={486.7} bold>
        DESCRIÇÃO DO(S) PORÃO(ÕES)
      </Centered>
      <Centered y={500.2} bold italic>
        Description of hold(s)
      </Centered>
    </Block>
  </>
)

const cell = { border: LINE, padding: 0, textAlign: 'center', height: `${ROW_HEIGHT}pt`, lineHeight: `${ROW_HEIGHT}pt` }

const HoldsTable = ({ data }) => (
  <table
    style={{
      width: `${WIDTH}pt`,
      borderCollapse: 'collapse',
      tableLayout: 'fixed',
      fontSize: `${SIZE}pt`,
      margin: '0 0 -1pt'
    }}
  >
    <colgroup>
      {COLUMNS.map(width => (
        <col key={width} style={{ width: `${width}pt` }} />
      ))}
    </colgroup>
    <tbody>
      <tr style={{ fontWeight: 'bold' }}>
        <td style={cell}>Nº do Porão / Hold</td>
        <td style={cell}>Cubagem (m3) / Cubic Meters</td>
        <td style={{ ...cell, fontSize: '8pt' }}>Quantidade de fumigante / Quantity of fumigantion product (kg)</td>
      </tr>
      {data.holds.map(({ hold, cubic, fumigant }) => (
        <tr key={hold}>
          <td style={{ ...cell, fontWeight: 'bold' }}>{hold}</td>
          <td style={cell}>{cubic}</td>
          <td style={cell}>{fumigant}</td>
        </tr>
      ))}
      <tr>
        <td style={{ ...cell, fontWeight: 'bold' }}>TOTAL</td>
        <td style={{ ...cell, fontWeight: 'bold' }}>{data.totalCubic}</td>
        <td style={cell}>{data.totalFumigant}</td>
      </tr>
    </tbody>
  </table>
)

const Footer = ({ data }) => (
  <>
    <Block top={640.1} height={51.6} plain>
      <At x={25.2} y={666.1}>
        Local/data:
      </At>
      <At x={122.3} y={666.1}>
        <span style={{ fontSize: '8pt' }}>{data.mapaPort}</span>{' '}
        ............../........................................../..................
      </At>
    </Block>
    <Block top={691.7} height={80.1} borders="tb">
      <At x={105.8} y={732.7}>
        <Bold>COMANDANTE / </Bold>
        <Bold>
          <i>MASTER</i>
        </Bold>
      </At>
      <At x={414.8} y={732.7}>
        <Bold>AGENTE / </Bold>
        <Bold>
          <i>AGENT</i>
        </Bold>
      </At>
    </Block>
  </>
)

const AuthorizationDocument = ({ data }) => (
  <div
    id="pdfPage"
    style={{ width: '595.2pt', boxSizing: 'border-box', padding: '10pt 9pt 0', background: '#fff', fontFamily: FONT }}
  >
    <style>{`@page { size: A4; margin: 0 }`}</style>
    <Sheet left={LEFT} style={{ width: `${WIDTH}pt`, color: '#000', fontSize: `${SIZE}pt` }}>
      <Header data={data} />
      <Text data={data} />
      <Summary data={data} />
      <HoldsTable data={data} />
      <Footer data={data} />
    </Sheet>
  </div>
)

export default AuthorizationDocument
